import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {

 



  measurementId: "G-S1DPCCYFYJ",
  apiKey: "AIzaSyD7QTvuDvvZsn1HW1qKOVKqNR_BldTppgY",
  authDomain: "pinme-4c5ad.firebaseapp.com",
  projectId: "pinme-4c5ad",
  storageBucket: "pinme-4c5ad.firebasestorage.app",
  messagingSenderId: "822307364158",
  appId: "1:822307364158:web:e74ef94a21c72928a1606f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const database = getDatabase(app);
const messaging = getMessaging(app);

// Export initialized Firebase services
export { db, database, messaging };
